module.exports = __webpack_public_path__ + "static/img/news.42b05fc2.png";